import { render } from "./collection.vue?vue&type=template&id=8a22de46&ts=true"
import script from "./collection.vue?vue&type=script&lang=ts"
export * from "./collection.vue?vue&type=script&lang=ts"

import "./collection.vue?vue&type=style&index=0&id=8a22de46&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__